<div class="flex flex-column gap-2">
    <div class="flex justify-content-center">
        <p-autoComplete [(ngModel)]="selectedTrailer" [group]="true" [suggestions]="filteredGroups"
            (completeMethod)="filterGroupedTrailers($event)" (onSelect)="selectedTrailer && onSelect(selectedTrailer)"
            appendTo="body" (onClear)="onClear()" [dropdownIcon]="'pi pi-search'" placeholder="Search for trailer..."
            [style]="{ width: '100%' }" [showClear]="true" [minLength]="1" field="trailer_number">
            <ng-template let-group pTemplate="group">
                <div class="flex align-items-center gap-2 p-2">
                    <span class="font-medium">{{ group.label }}</span>
                    <span class="text-sm text-500">({{ group.items.length }} trailers)</span>
                </div>
            </ng-template>
            <ng-template let-item pTemplate="item">
                <div class="flex align-items-center justify-content-between p-2">
                    <span>{{ item.trailer_number }}</span>
                    <span *ngIf="getDriverNameByTrailerId(item.trailer_id) !== 'Unknown Driver'" class="text-xs px-2 py-1 bg-primary-100 text-primary-700 border-round">
                        {{ getDriverNameByTrailerId(item.trailer_id) }}
                    </span>
                </div>
            </ng-template>
        </p-autoComplete>
    </div>
    <div class="flex flex-column"></div>
    <p-accordion [multiple]="true" [activeIndex]="[0]">
        <p-accordionTab *ngFor="let location of displayedLocations; let i = index" [header]="location.title">
            <div class="flex flex-column">
                <!-- Empty state -->
                <div *ngIf="location.content.length === 0" class="text-500 text-center py-1">
                    No trailers at this location
                </div>
                <!-- Trailer items -->
                <div *ngFor="let trailer of location.content">
                    <div class="p-2 border-round surface-50 relative mb-2 border-1 surface-border hover:surface-100 transition-colors transition-duration-150">
                        <!-- Header with basic info -->
                        <div class="flex align-items-center justify-content-between cursor-pointer" 
                             (click)="toggleTrailerDetails(trailer)">
                            <div class="flex align-items-center gap-2">
                                <span class="font-semibold text-900">{{trailer.trailer_number}}</span>
                                <!-- Status indicators matching equipment page style -->
                                <span *ngIf="getTrailerLoadStatus(trailer) === 'Loaded' || getTrailerLoadStatus(trailer) === 'Empty'" 
                                      class="px-2 py-1 border-round flex align-items-center"
                                      [ngClass]="{
                                        'bg-yellow-100 text-yellow-800': getTrailerLoadStatus(trailer) === 'Loaded',
                                        'bg-green-100 text-green-800': getTrailerLoadStatus(trailer) === 'Empty'
                                      }"
                                      style="font-size: 0.75rem; font-weight: 600;">
                                  <span class="mr-1" style="display: inline-block; width: 0.7rem; height: 0.7rem; border-radius: 50%; background-color: currentColor;" *ngIf="getTrailerLoadStatus(trailer) === 'Empty'"></span>
                                  <i class="pi pi-check-circle mr-1" style="font-size: 0.7rem;" *ngIf="getTrailerLoadStatus(trailer) === 'Loaded'"></i>
                                  <span>{{ getTrailerLoadStatus(trailer) }}</span>
                                </span>
                                <!-- Special status pill for Higrade or Sea Salt when loaded -->
                                <span *ngIf="shouldShowSpecialStatusPill(trailer)" 
                                      class="px-2 py-1 border-round flex align-items-center"
                                      [ngClass]="{
                                        'bg-purple-100 text-purple-800': getSpecialStatus(trailer) === 'Higrade',
                                        'bg-blue-100 text-blue-800': getSpecialStatus(trailer) === 'Sea Salt'
                                      }"
                                      style="font-size: 0.75rem; font-weight: 600;">
                                  <i class="pi pi-star mr-1" style="font-size: 0.7rem;"></i>
                                  <span>{{ getSpecialStatus(trailer) }}</span>
                                </span>
                                <span *ngIf="getDriverNameByTrailerId(trailer.trailer_id) !== 'Unknown Driver'" class="text-xs px-2 py-1 bg-primary-100 text-primary-700 border-round">
                                    {{ getDriverNameByTrailerId(trailer.trailer_id) }}
                                </span>
                            </div>
                            <div class="flex align-items-center gap-2">
                                <i class="pi text-sm text-500 transition-transform transition-duration-150" 
                                   [ngClass]="expandedTrailers[trailer.trailer_id] ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                            </div>
                        </div>
                        
                        <!-- Expandable Details -->
                        <div *ngIf="expandedTrailers[trailer.trailer_id]" 
                             class="mt-2 pt-2 border-top-1 surface-border animate-fadein">
                            <div *ngIf="isTrailerLoaded(trailer) || getPickupNumber(trailer)" class="flex flex-column gap-1 text-sm">
                                <!-- Compact info rows -->
                                <div *ngIf="isTrailerLoaded(trailer)" class="flex align-items-center justify-content-between py-1">
                                    <span class="text-600 font-medium">Customer:</span>
                                    <span class="text-900 text-right">{{getCustomerName(trailer)}}</span>
                                </div>
                                <div *ngIf="getPickupNumber(trailer) && isTrailerLoaded(trailer)" class="flex align-items-center justify-content-between py-1">
                                    <span class="text-600 font-medium">Pickup #:</span>
                                    <span class="text-900 font-mono">{{getPickupNumber(trailer)}}</span>
                                </div>
                            </div>
                            <div *ngIf="!isTrailerLoaded(trailer)" class="flex flex-column gap-1 text-sm">
                                <div class="flex align-items-center justify-content-between py-1">
                                    <span class="text-600 font-medium">Status:</span>
                                    <span class="text-900 text-right">No Order Info</span>
                                </div>
                            </div>
                            <!-- Move trailer button for admin users -->
                            <div *ngIf="hasAccess" class="mt-2 pt-2 border-top-1 surface-border">
                                <p-button icon="pi pi-map-marker" 
                                         label="Move" 
                                         size="small"
                                         [outlined]="true"
                                         class="w-full"
                                         (click)="openLocationDialog(trailer); $event.stopPropagation()">
                                </p-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>


<p-dialog [(visible)]="displayDialog" [style]="{width: '450px', height:'full'}" header="Move Trailer" [modal]="true"
    [draggable]="false" [resizable]="false" (onHide)="reset()">

    <div class="flex flex-column gap-3 w-full p-3">
        <div *ngIf="selectedTrailer" class="flex flex-column gap-3">
            <!-- Current trailer info -->
            <div class="flex align-items-center gap-2">
                <span class="font-medium">Trailer:</span>
                <span>{{selectedTrailer.trailer_number}}</span>
            </div>

            <!-- Location dropdown -->
            <div class="flex flex-column gap-2">
                <label for="location" class="font-medium">Move to Location:</label>
                <p-dropdown id="location" [options]="getAvailableLocations(selectedTrailer)"
                    [(ngModel)]="selectedNewLocation" optionLabel="label" [style]="{'width': '100%'}"
                    placeholder="Select a location" [showClear]="true" [appendTo]="'body'">
                </p-dropdown>
            </div>

            <!-- Driver selection -->

            <div *ngIf="selectedNewLocation?.label == 'Driver'">
                <label for="driver" class="font-medium">Assign Driver:</label>
                <p-dropdown id="driver" [options]="drivers" [(ngModel)]="selectedDriver" [style]="{'width': '100%'}"
                    placeholder="Select a driver (optional)" [showClear]="true" [appendTo]="'body'"
                    [virtualScroll]="true" [virtualScrollItemSize]="38">
                    <ng-template pTemplate="selectedItem" let-driver>
                        <div *ngIf="driver">
                            {{driver.first_name}} {{driver.last_name}}
                        </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-driver>
                        <div>
                            {{driver.first_name}} {{driver.last_name}}
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <button pButton pRipple icon="pi pi-times" class="p-button-outlined" label="Cancel"
                (click)="displayDialog = false">
            </button>
            <button pButton pRipple icon="pi pi-check" label="Move" (click)="saveNewLocation()">
            </button>
        </div>
    </ng-template>
</p-dialog>


<!-- Hidden assign-equipment component for logic reuse -->
<app-assign-equipment #equipmentAssigner 
  [trailers]="trailers" 
  [drivers]="drivers" 
  style="display: none;">
</app-assign-equipment>

<p-toast></p-toast>

<p-confirmPopup key="popup"></p-confirmPopup>